import { registerPlugin } from '@capacitor/core';

export interface DeviceIdPlugin {
  getAndroidId(): Promise<{ deviceId: string }>;
}

export const DeviceId = registerPlugin<DeviceIdPlugin>('DeviceId');
